export enum TabSize {
  /** å¡ççº§å°ºå¯¸ */
  Large = 'large',

  /** é¡µé¢çº§å°ºå¯¸ */
  Medium = 'medium',

  /** å°å°ºå¯¸ */
  Small = 'small',
}

export enum TabType {
  Line = 'line',
  Card = 'card',
}
